import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-masterpage',
  templateUrl: './masterpage.component.html',
  styleUrls: ['./masterpage.component.css']
})
export class MasterPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
